<template>
  <div>
    <b-modal
      id="age-restriction-modal"
      ref="modal"
      title=""
      hide-footer
      hide-header
      centered
      no-close-on-backdrop
    >
      <div class="header">
        <h3>Вам исполнилось 18 лет? <br /><br /></h3>

        <p class="w-100">
          Сайт доступен только для лиц старше 18 лет. <br/>
          Подтвердите, пожалуйста, свой возраст.
        </p>
      </div>

      <div class="buttons-wrapper">
        <b-button
          class="button"
          @click="$bvModal.hide('age-restriction-modal')"
          variant="primary"
          >Да, мне есть 18</b-button
        >

        <b-button class="button" variant="primary" type="submit" @click="submit"
          >Нет, мне нет 18</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["noBtn"],

  data() {
    return {};
  },

  mounted() {},

  methods: {
    submit() {
      this.$bvModal.hide("age-restriction-modal");
      this.$bvModal.show("error-age");
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

h3 {
  font-size: 35px !important;
  margin-bottom: 28px !important;
  text-align: center !important;
  color: white;
  text-transform: uppercase;
  font-weight: 700 !important;
  font-family: $regular !important;
  margin-top: 0 !important;

  @media (max-width: 1044px) {
    font-size: 30px !important;
  }

  @media (max-width: 768px) {
    font-size: 28px !important;
  }

  @media (max-width: 576px) {
    font-size: 20px !important;
    margin-bottom: 8px !important;
    font-weight: 600 !important;
  }
}

p {
  font-size: 24px;
  text-align: center;
  color: white;
  font-family: $regular !important;
  line-height: 124%;
  font-weight: 200 !important;

  @media (max-width: 1044px) {
    font-size: 21px !important;
  }

  @media (max-width: 768px) {
    font-size: 18px !important;
  }

  @media (max-width: 576px) {
    font-size: 14px !important;
    line-height: 18px;
  }
}

.buttons-wrapper {
  margin-top: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (max-width: 999px) {
    margin-top: 45px;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    margin-top: 20px;
  }
}

.button {
  width: 100%;
  max-width: 355px;
  height: 64px;
  font-size: 20px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background-color: transparent;
  transition: 0.4s all;
  background-image: url("@/assets/button-bg.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: contain;
  font-weight: 600;

  &:hover {
    background-color: transparent;
    opacity: 0.6;
    transition: 0.4s all;
  }

  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  &:first-child {
    margin-right: 30px;
  }

  @media (max-width: 1044px) {
    font-size: 20px !important;
  }

  @media (max-width: 999px) {
    font-size: 18px !important;
    height: 50px;
  }

  @media (max-width: 576px) {
    max-width: 290px;
    font-size: 14px !important;

    &:first-child {
      margin-right: 0;
      margin-bottom: 7px;
    }
  }
}
</style>
